import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldAlert } from 'lucide-react';
const plans = [{
  name: 'Recon',
  price: '€2,490',
  period: '/mo',
  target: 'For growing teams (up to 50 endpoints)',
  features: ['Bastion Shield Endpoint Protection', 'Standard Threat Intelligence Feed', '24/7 Automated Monitoring', 'Email & Slack Support', 'Monthly Security Audits'],
  popular: false,
  cta: 'Start Recon'
}, {
  name: 'Fortify',
  price: '€6,750',
  period: '/mo',
  target: 'For mid-market (up to 500 endpoints)',
  features: ['Everything in Recon', 'Cipher Veil Encryption Suite', 'Sentinel Mesh Network Analysis', 'Priority Incident Response (< 15m)', 'Dedicated Security Analyst', 'Compliance Reporting (GDPR, NIS2)'],
  popular: true,
  cta: 'Deploy Fortify'
}, {
  name: 'Citadel',
  price: 'Custom',
  period: '',
  target: 'Enterprise-grade, unlimited endpoints',
  features: ['Everything in Fortify', 'Aegis Pulse AI Integration', 'Custom Playbook Development', 'On-premise Deployment Options', 'Board-level Risk Reporting', 'Zero-day Vulnerability Hunting'],
  popular: false,
  cta: 'Contact Sales'
}];
export function PricingSection() {
  return <section id="pricing" className="py-24 bg-brand-dark relative" data-id="element-143">
      <div className="container mx-auto px-6" data-id="element-144">
        <div className="text-center mb-16" data-id="element-145">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-mono font-bold text-white mb-6" data-id="element-146">
            Security Tiers
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-slate-400 text-lg max-w-2xl mx-auto" data-id="element-147">
            Transparent pricing for military-grade protection. Billed annually.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-148">
          {plans.map((plan, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`relative bg-brand-darker rounded-xl border ${plan.popular ? 'border-brand-steel shadow-[0_0_30px_rgba(74,144,217,0.15)]' : 'border-brand-border'} p-8 flex flex-col`} data-id="element-149">
              {plan.popular && <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-steel text-white font-mono text-xs font-bold px-4 py-1 rounded-full uppercase tracking-wider flex items-center gap-1" data-id="element-150">
                  <ShieldAlert className="w-3 h-3" data-id="element-151" />
                  Recommended
                </div>}

              <div className="mb-8" data-id="element-152">
                <h3 className="text-2xl font-mono font-bold text-white mb-2" data-id="element-153">
                  {plan.name}
                </h3>
                <p className="text-sm text-slate-400 mb-6 h-10" data-id="element-154">
                  {plan.target}
                </p>
                <div className="flex items-baseline gap-1" data-id="element-155">
                  <span className="text-4xl font-bold text-white" data-id="element-156">
                    {plan.price}
                  </span>
                  <span className="text-slate-400 font-mono" data-id="element-157">
                    {plan.period}
                  </span>
                </div>
              </div>

              <ul className="space-y-4 mb-8 flex-grow" data-id="element-158">
                {plan.features.map((feature, fIndex) => <li key={fIndex} className="flex items-start gap-3 text-sm text-slate-300" data-id="element-159">
                    <Check className="w-5 h-5 text-brand-cyan shrink-0" data-id="element-160" />
                    <span data-id="element-161">{feature}</span>
                  </li>)}
              </ul>

              <a href="#contact" className={`w-full py-3 px-4 rounded-md font-mono text-sm font-medium text-center transition-all ${plan.popular ? 'bg-brand-steel hover:bg-brand-steel-light text-white shadow-[0_0_15px_rgba(74,144,217,0.3)]' : 'bg-transparent border border-brand-border hover:border-brand-steel text-white'}`} data-id="element-162">
                {plan.cta}
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}